/* eslint-disable camelcase */
import { Backend } from '@/_axios';

export default {
  all() {
    return Backend.get('/api/all_clients');
  },
};
